import withStyles from "@material-ui/styles/withStyles"
import React, { Component } from "react"
import rebase from "../../../config/rebase"

import { Typography } from "@material-ui/core"
import CustomBtn from "../../../components/Buttons/CustomBtn"
import CustomCardItem from "../../../components/Cards/CustomCardItem"
import Wrapper from "../../../components/Common/Wrapper"
import CustomAlert from "../../../components/CustomAlert"
import AttributionView from "../../../components/Grade/AttributionView"
import Status from "../../../components/Paper/Status"
import ThreeAsTwo from "../../../components/Steps/ThreeAsTwo"
import { dbPrefix } from "../../../Constants"
import { getReportsForPaper } from "../../../rebaseService"
import { isGradeAssignmentAvailable } from "../../../utils"

const styles = theme => ({
  paper: {
    margin: '10px',
    padding: theme.spacing(3),
    textAlign: "left",
    color: theme.palette.text.secondary
  },
  root: {
    flexGrow: 1,
    marginTop: '72px',
  },
  grid: {
    width: 1200,
    marginTop: 40,
    [theme.breakpoints.down("sm")]: {
      width: "calc(100% - 20px)"
    }
  },
  rangeLabel: {
    display: "flex",
    justifyContent: "space-between",
    paddingTop: theme.spacing(2)
  },
  topBar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 32
  },
  outlinedButtom: {
    textTransform: "uppercase",
    margin: theme.spacing(1)
  },
  actionButtom: {
    textTransform: "uppercase",
    margin: theme.spacing(1),
    width: 152
  },
  blockCenter: {
    padding: theme.spacing(2),
    textAlign: "center"
  },
  block: {
    padding: theme.spacing(2)
  },
  box: {
    marginBottom: 40,
    height: 65
  },
  inlining: {
    display: "inline-block",
    marginRight: 10
  },
  buttonBar: {
    display: "flex"
  },
  alignRight: {
    display: "flex",
    justifyContent: "flex-end"
  },
  noBorder: {
    borderBottomStyle: "hidden"
  },
  loadingState: {
    opacity: 0.05
  },
  loadingMessage: {
    position: "absolute",
    top: "40%",
    left: "40%"
  }
})

class Papers extends Component {

  state = {
    paper: false,
    users: [],
    loaded: false,
    showDialog: false,
    grade: null,
    inputError: false,
    comissionAccount: {},
  }

  async componentDidMount() {
    const { id } = this.props.match.params
    this.setState({ id })
    if (!id) {
      return window.location.replace('/')
    }

    try {
      let paper = await rebase.fetch(dbPrefix + 'papers/' + id, {
        asArray: false
      })
      let reports = []
      reports = await getReportsForPaper(paper.knowledgeArea, id)
      paper.reports = reports

      this.setState({ paper })

      if (paper) {
        for (let index = 0; index < paper.usersId.length; index++) {
          const cpf = paper.usersId[index]

          const user = await rebase.fetch(dbPrefix + 'users/' + cpf, {
            asArray: false
          })
          this.setState({ users: [...this.state.users, user] })
        }
        // Pega accessCodes
        // pela area de conhecimento atribuida às comissões
        const comissionAccount = await rebase.fetch(dbPrefix + 'users/', {
          asArray: true,
          queries: {
            orderByChild: "knowledgeArea",
            equalTo: paper.knowledgeArea
          }
        })
        this.setState({ comissionAccount: comissionAccount[0] })

      } else {
        return window.location.replace('/')
      }

    } catch (error) {
      console.log(error)
      this.setState({ error: "Ocorreu um erro..." })
    } finally {
      this.setState({ loaded: true })
    }
  }

  classify() {
    rebase.update(dbPrefix + 'papers/' + this.state.id, {
      data: {
        presentable: true
      }
    }).then(() => {
      this.setState({ success: "Banner classificado com sucesso!", paper: { ...this.state.paper, presentable: true } })
    }).catch(error => {
      console.log(error)
      this.setState({ error })
    }).finally(() => {
      this.setState({ loaded: true, showSaveBannerDialog: false })
    })
  }

  render() {
    const { classes } = this.props

    const { paper, users } = this.state

    return (
      <Wrapper loaded={this.state.loaded} success={this.state.success} fatalError={this.state.error} currentPath={"/admin/papers"} adminTopbar>
        {this.state.loaded && <>
          <Status accepted={paper.accepted} finalGrade={paper.finalGrade} />
          <ThreeAsTwo
            readOnly
            asAdmin
            firstAuthor={paper.firstAuthor}
            knowledgeArea={paper.knowledgeArea}
            paperTitle={paper.paperTitle}
            paperFile={paper.paperFile}
            videoLink={paper.videoLink}
            paperURL={paper.paperURL}
            paperURL2={paper.paperURL2}
            abstract={paper.abstract}
            classes={classes}
            users={users}
          />
          {
            !isGradeAssignmentAvailable() && <CustomCardItem>
              <CustomAlert message="A avaliação não é permitida neste período" />
            </CustomCardItem>
          }

          {
            paper.banner && paper.accepted && paper.bannerURL && <>
              <CustomCardItem>
                <Typography variant="h3">Banner depositado</Typography>
                <img className="bannerImg" src={paper.bannerURL} alt="Banner depositado" />
                {!paper.presentable && <CustomBtn fullWidth title="Classificar" onClick={() => this.classify()} />}
              </CustomCardItem>
            </>
          }
          {
            paper.banner && paper.accepted && !paper.bannerURL && <>
              <CustomCardItem>
                <Typography variant="h3" color="error">Banner ainda não depositado</Typography>
              </CustomCardItem>
            </>
          }
          <CustomCardItem>
            <Typography variant="h3">Quem avaliou</Typography>
            {
              paper.reports.length > 0 ?
                paper.reports.map((r) => (
                  r.status === 'open' ?
                    <Typography key={r.reviewer}>Avaliação em andamento para {r.reviewer}</Typography>
                    :
                    <AttributionView
                      key={r.reviewer}
                      accepted={(r.accepted || "").toString()}
                      coiText={r.coiText}
                      comment={r.comment}
                      hasCoi={(r.status === 'coi').toString()}
                      needsChanges={r.needsChanges}
                      observation={r.observation}
                      accessCode={r.reviewer}
                      grades={{
                        abstract: r.abstract,
                        introduction: r.introduction,
                        matnmet: r.matnmet,
                        resndis: r.resndis,
                        conclusion: r.conclusion,
                        ref: r.ref
                      }}
                    />
                ))
                :
                null
            }
            <Typography variant="h6">{paper.reports.length ? `Avaliações: ${paper.reports.length}` : "Ainda não há avaliações"} </Typography>
          </CustomCardItem>
        </>
        }
      </Wrapper>
    )
  }
}
export default withStyles(styles)(Papers)
